import React, {useState, useEffect} from 'react'
import {useSelector} from 'react-redux'
import {ImageFormatter} from './formatters/ImageFormatter'
import PriceHistory from './modal/PriceHistory'

const CardDetails =  (props) => {

    const cardData = useSelector(state => state.cardGrid)
    const [loading, setLoading] = useState('ui  dimmer')
    const [currImg, setCurrImg] = useState({})

    useEffect(() => {  

        const imgUrl = cardData.cardGridData && cardData.cardGridData[cardData.selectedCard] ? cardData.cardGridData[cardData.selectedCard].imageUrl : ''
        const cardLabel = cardData.cardGridData && cardData.cardGridData[cardData.selectedCard] && cardData.cardGridData[cardData.selectedCard].label ? cardData.cardGridData[cardData.selectedCard].label : ''
        const cardGrade = cardData.cardGridData && cardData.cardGridData[cardData.selectedCard] && cardData.cardGridData[cardData.selectedCard].graded && cardData.cardGridData[cardData.selectedCard].graded !== 'RAW' ? cardData.cardGridData[cardData.selectedCard].graded + ' ' + cardData.cardGridData[cardData.selectedCard].condition : 'RAW'
        const setName = cardData.cardGridData && cardData.cardGridData[cardData.selectedCard] && cardData.cardGridData[cardData.selectedCard].setName ? cardData.cardGridData[cardData.selectedCard].setName : ''
        const player = cardData.cardGridData && cardData.cardGridData[cardData.selectedCard] && cardData.cardGridData[cardData.selectedCard].player ? cardData.cardGridData[cardData.selectedCard].cardNum + ' ' + cardData.cardGridData[cardData.selectedCard].player : ''
        const condition = cardData.cardGridData && cardData.cardGridData[cardData.selectedCard] && cardData.cardGridData[cardData.selectedCard].condition ? cardData.cardGridData[cardData.selectedCard].graded + ' ' + cardData.cardGridData[cardData.selectedCard].condition : ''
        const serialNumber = cardData.cardGridData && cardData.cardGridData[cardData.selectedCard] && cardData.cardGridData[cardData.selectedCard].serialNumber ? cardData.cardGridData[cardData.selectedCard].serialNumber  : ''


        setCurrImg({
            imgUrl,
            cardLabel,
            cardGrade, 
            setName,
            player,
            condition,
            serialNumber
        })
      }, [cardData.cardGridData, cardData.selectedCard]);



    useEffect(() => {  //Set Formik state with actual name
        if (cardData.priceLoading) {
            setLoading('ui active dimmer')
        }
        else {
            setLoading('ui dimmer')
        }
      }, [cardData.priceLoading]);

      //TODO: UPDATE IMAGE WHEN THE SELECTED CARD CHANGES IN REDUX STATE


    function renderPriceData(userPresent) {
        if (userPresent) {
            return (
                <div className="content">
                            <a href="http://localhost:3000" className="header">Card Sales Data ({cardData.selectedCardDetails ? cardData.selectedCardDetails.count : 0}) Cards</a><PriceHistory cardLabel={currImg.cardLabel} cardGrade={currImg.cardGrade}/>
                            <div className='ui tiny statistics'>
                                    <div className="ui tiny red statistic">
                                        <div className="value">
                                        {cardData.selectedCardDetails ? cardData.selectedCardDetails.bargain : 0}
                                        </div>
                                        <div className="label">
                                        Bargain
                                        </div>
                                    </div>
                                    <div className="ui tiny statistic">
                                        <div className="value">
                                        {cardData.selectedCardDetails ? cardData.selectedCardDetails.median : 0}
                                        </div>
                                        <div className="label">
                                        Median
                                        </div>
                                    </div>
                                    <div className="ui green tiny statistic">
                                        <div className="value">
                                        {cardData.selectedCardDetails ? cardData.selectedCardDetails.topDollar : 0}
                                        </div>
                                        <div className="label">
                                        Top Dollar
                                        </div>
                                    </div>
                                </div>
                            <div className="description">
                            </div>
                        </div>
            )
            }
            else {
                return (
                    <div className="content"></div>
                )
            }
    }
    if (currImg.imgUrl) {
        return (
            <div className="ui container">
                <div className={loading}>
                    <div className="ui loader"></div>
                </div>
                <div className="ui card">
                    <ImageFormatter value={currImg.imgUrl} isGallery={props.isGallery} imgStyle={"full"} />
                    <div className="content">
                        <div className="ui items">
                            <div className="item">
                                <div className="left aligned content">
                                    <div className="header">{currImg.setName}</div>
                                </div>
                            </div>
                            <div className="item">
                                <div className="left aligned content">
                                    <div className="header">{currImg.player}</div>
                                </div>
                            </div>
                            <div className="item">
                                <div className="left aligned content">
                                    <div className="header">Serial Number:  {currImg.serialNumber}</div>
                                </div>
                            </div>
                            <div className="item">
                                <div className="left aligned content">
                                    <div className="header">{currImg.condition}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {renderPriceData(cardData.isUserLoggedIn)}
                </div>
            </div>
        )
    }
    else {
        return <div></div>
    }
}
export default CardDetails